import React, { Component } from "react";

class JobFinished extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printer: props.printer,
    };
  }

  render() {
    const { finishedJob } = this.props;

    const pricing = this.state.printer.state.computerUser.pricing;

    let currency_symbol;
    let icon;
    if (finishedJob) {
      switch (finishedJob.cost_currency) {
        case "ils":
          currency_symbol = "₪";
          break;
        case "usd":
          currency_symbol = "$";
          break;
      }
      switch (finishedJob.action) {
        case "print":
          icon = "fa-print";
          break;
        case "copy":
          icon = "fa-clone";
          break;
        case "scan":
          icon = "fa-scanner-image";
          break;
      }
    }

    const divider = <div className="divider top-10 bottom-10"></div>;

    return (
      <div
        id="menu-job-finished"
        className="menu menu-box-bottom"
        data-menu-effect="menu-over"
        data-menu-select="page-components"
        style={{ height: "auto", opacity: 1, display: "block" }}
      >
        <div className="top-20">
          <h2 className="uppercase bold">Job finished</h2>
          <p className="under-heading bottom-20">
            Your job finished successfuly
          </p>
          <div className="center-text-huge bottom-0">
            <div className="content">
              <div className="price-item">
                <span className="color-theme regularbold font-16">Pages</span>
                <span className="color-theme regularbold font-16">
                  <i className="fal fa-clone"></i>{" "}
                  {Number(finishedJob.pages) * Number(finishedJob.copies)}
                </span>
              </div>
              {pricing && divider}
              {pricing && (
                <div className="price-item">
                  <span className="color-theme regularbold font-16">Cost</span>
                  <span className="color-theme regularbold font-16">
                    {currency_symbol}{" "}
                    {Number(finishedJob.cost_amount)
                      ? Number(finishedJob.cost_amount).toFixed(2)
                      : (0).toFixed(2)}
                  </span>
                </div>
              )}
            </div>
          </div>
          <a
            href="#"
            className="close-menu button button-s button-center-large button-round-medium shadow-large bg-highlight"
          >
            Close
          </a>
        </div>
      </div>
    );
  }
}

export default JobFinished;



// WEBPACK FOOTER //
// ./src/components/pages/printer/jobFinished.js